import L from 'leaflet';
import serializeStyle from '../serializeStyle';
import './index.css';

const OPTIONS = {
  latLng: [51.505, -0.09],
  index: '1',
  size: {
    height: '0.5rem',
    width: '0.5rem'
  }
};

const rootSize = parseInt(document.documentElement.style.fontSize, 10);

export default function indexMarker(options = {}, markerOptions = {}) {
  options = {...OPTIONS, ...options};

  let size = serializeStyle({...options.size});

  let icon = L.divIcon({
    iconSize: [
      rootSize * parseFloat(options.size.width),
      rootSize * parseFloat(options.size.height)
    ],
    className: 'component-map-index-marker',
    html: `<div style="${size}" class="marker-outer"><div class="marker-inner">${options.index}</div></div>`
  });

  markerOptions.icon = icon;

  let marker = L.marker(options.latLng, markerOptions);

  return marker;
}



// WEBPACK FOOTER //
// ./src/components/Map/indexMarker/index.js